/*
 * Header
 */

// Header Space
document.addEventListener("DOMContentLoaded", function() {
  var header = document.querySelector("#header"); // ヘッダーの要素を取得

  if (header) {
    var headerHeight = header.offsetHeight; // ヘッダーの高さを取得
    document.documentElement.style.setProperty("--header-height", headerHeight + "px"); // CSS変数に設定
  }
});


/*
 * Drawer
 */

// コンテンツを表示

document.addEventListener("click", function (event) {
  const drawer = document.getElementById("drawer");
  const drawerInbox = document.querySelector("#drawer .inbox");

  // 共通: 閉じる処理
  const closeDrawer = () => {
    document.body.classList.remove("--draweropen");
    const activeContent = document.querySelector("#drawer .drawer-content[data-active]");
    if (activeContent) activeContent.removeAttribute("data-active");
    document.querySelectorAll(".drawer-handle").forEach((btn) => btn.classList.remove("active"));
  };

  // 内部リンク判定（#アンカー or 同一オリジン&同一パス）
  const isInternalLink = (a) => {
    if (!a) return false;
    if (a.target === "_blank" || a.hasAttribute("download")) return false;
    const rawHref = a.getAttribute("href") || "";
    if (rawHref.startsWith("#")) return true; // ページ内リンク
    const url = new URL(a.href, location.href);
    return url.origin === location.origin && url.pathname === location.pathname;
  };

  // ① ドロワー内リンクをクリックしたら閉じる
  const link = event.target.closest("#drawer a");
  if (document.body.classList.contains("--draweropen") && link && isInternalLink(link)) {
    // ここでは基本 preventDefault しない（遷移/スクロールを妨げない）
    closeDrawer();
    // もしスムーススクロール等の別JSと競合するなら、ここで setTimeout(closeDrawer, 0) にしてもOK
  }

  // ② ハンドルの開閉/切替ロジック（元の処理を維持）
  const handle = event.target.closest(".drawer-handle");
  if (handle) {
    const target = handle.dataset.target;
    if (!target) return;

    const activeContent = document.querySelector("#drawer .drawer-content[data-active]");
    const newContent = document.querySelector(`#drawer .drawer-content[drawer-data="${target}"]`);

    if (!document.body.classList.contains("--draweropen")) {
      document.body.classList.add("--draweropen");
    }

    if (activeContent !== newContent) {
      if (activeContent) activeContent.removeAttribute("data-active");
      if (newContent) newContent.setAttribute("data-active", "true");
      document.querySelectorAll(".drawer-handle").forEach((btn) => btn.classList.remove("active"));
      handle.classList.add("active");
    } else {
      closeDrawer(); // 同じボタンで閉じる
    }
    return;
  }

  // ③ オーバーレイ（inbox 以外の drawer 部分）クリックで閉じる
  if (document.body.classList.contains("--draweropen")) {
    if (drawer.contains(event.target) && !drawerInbox.contains(event.target)) {
      closeDrawer();
    }
  }
});
